import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

/* history mode IIS url rewrite for web.config, excluding api subfolder.
    <rewrite>
      <rules>
        <rule name="Handle History Mode and custom 404/500" stopProcessing="true">
          <match url="(.*)" />
          <conditions logicalGrouping="MatchAll">
            <add input="{REQUEST_FILENAME}" matchType="IsFile" negate="true" />
            <add input="{REQUEST_FILENAME}" matchType="IsDirectory" negate="true" />
            <add input="{REQUEST_URI}" url="^api/.*" negate="true" />
          </conditions>
          <action type="Rewrite" url="/" />
        </rule>
      </rules>
    </rewrite>
*/
const router = new Router({
    //mode: 'hash',
    mode: "history",
    //base: process.env.BASE_URL,
    routes: [
        {
            path: "/accisureform",
            name: "accisureform",
            component: () => import(/* webpackChunkName: "AccisureForm" */ "./views/AccisureForm.vue"),
        },
        {
            path: "/Login",
            name: "Login",
            component: () => import(/* webpackChunkName: "Login" */ "./views/Login.vue"),
            beforeEnter: (to, from, next) => {
                if (store.getters["authentication/isLoggedIn"]) next({ name: "Layout" });
                else next();
            },
        },
        {
            path: "/MyMembershipCard/:year/:month/:day/:guid",
            name: "MyMembershipCard",
            components: { default: () => import(/* webpackChunkName: "MyMembershipCard" */ "./views/MyMembershipCard.vue") },
            props: { default: (route) => ({ year: route.params.year, month: route.params.month, day: route.params.day, guid: route.params.guid }) },
        },
        {
            path: "/",
            name: "Layout",
            component: () => import(/* webpackChunkName: "SideNavigation" */ "./layouts/SideNavigation.vue"),
            redirect: "Dashboard",
            meta: { requiresAuth: true },
            children: [
                {
                    path: "Accounts/:claimId?",
                    name: "Accounts",
                    components: { default: () => import(/* webpackChunkName: "Accounts" */ "./views/Accounts.vue") },
                    props: {
                        default: (route) => ({
                            providerId: route.params.providerId,
                            areaId: route.params.areaId,
                            patientId: route.params.patientId,
                            accountId: route.params.accountId,
                            isPaid: route.params.isPaid,
                            inClaim: route.params.inClaim,
                            ageing: route.params.ageing,
                            accountStatus: route.params.accountStatus,
                            agedDaysMin: route.params.agedDaysMin,
                            agedDaysMax: route.params.agedDaysMax,
                            hasFinalAccount: route.params.hasFinalAccount,
                            claimHasPodFile: route.params.claimHasPodFile,
                            inDayBatch: route.params.inDayBatch,
                            notReadyToBePrinted: route.params.notReadyToBePrinted,
                            agedDaysMinByAcceptedAt: route.params.agedDaysMinByAcceptedAt,
                            agedDaysMaxByAcceptedAt: route.params.agedDaysMaxByAcceptedAt,
                            agedDaysMinByVerifiedAt: route.params.agedDaysMinByVerifiedAt,
                            agedDaysMaxByVerifiedAt: route.params.agedDaysMaxByVerifiedAt,
                            agedDaysMinByProcessedAt: route.params.agedDaysMinByProcessedAt,
                            agedDaysMaxByProcessedAt: route.params.agedDaysMaxByProcessedAt,
                            agedDaysMinByQueriedAt: route.params.agedDaysMinByQueriedAt,
                            agedDaysMaxByQueriedAt: route.params.agedDaysMaxByQueriedAt,
                            claimId: route.params.claimId,
                            agedDaysMinByRejectedAt: route.params.agedDaysMinByRejectedAt,
                            agedDaysMaxByRejectedAt: route.params.agedDaysMaxByRejectedAt,
                        }),
                    },
                },
                {
                    path: "Claims",
                    name: "Claims",
                    components: { default: () => import(/* webpackChunkName: "Claims" */ "./views/Claims.vue") },
                    props: {
                        default: (route) => ({
                            providerId: route.params.providerId,
                            areaId: route.params.areaId,
                            agedDaysMin: route.params.agedDaysMin,
                            agedDaysMax: route.params.agedDaysMax,
                            noDaybatchNoPrinted: route.params.noDaybatchNoPrinted,
                            isPrinted: route.params.isPrinted,
                        }),
                    },
                },
                {
                    path: "ClaimsPostSubmission",
                    name: "ClaimsPostSubmission",
                    components: { default: () => import(/* webpackChunkName: "ClaimsPostSubmission" */ "./views/ClaimsPostSubmission.vue") },

                    props: {
                        default: (route) => ({
                            acceptedNotSubmitted: route.params.acceptedNotSubmitted,
                            unresolvedRejection: route.params.unresolvedRejection,
                            unresolvedObjection: route.params.unresolvedObjection,
                            submittedMissingLink: route.params.submittedMissingLink,
                            submittedWithLink: route.params.submittedWithLink,
                            shortPaid: route.params.shortPaid,
                            fullPaid: route.params.fullPaid,
                            providerId: route.params.providerId,
                            areaId: route.params.areaId,
                            agedDaysMin: route.params.agedDaysMin,
                            agedDaysMax: route.params.agedDaysMax,
                            isFinal: route.params.isFinal,
                            claimStatus: route.params.claimStatus,
                            agedDaysMinObjection: route.params.agedDaysMinObjection,
                            agedDaysMaxObjection: route.params.agedDaysMaxObjection,
                            agedDaysMinRejection: route.params.agedDaysMinRejection,
                            agedDaysMaxRejection: route.params.agedDaysMaxRejection,
                            agedDaysMinSubmission: route.params.agedDaysMinSubmission,
                            agedDaysMaxSubmission: route.params.agedDaysMaxSubmission,
                            agedDaysMinQueried: route.params.agedDaysMinQueried,
                            agedDaysMaxQueried: route.params.agedDaysMaxQueried,
                            agedDaysMinStatusRD: route.params.agedDaysMinStatusRD,
                            agedDaysMaxStatusRD: route.params.agedDaysMaxStatusRD,
                            agedDaysMinStatusVV: route.params.agedDaysMinStatusVV,
                            agedDaysMaxStatusVV: route.params.agedDaysMaxStatusVV,
                            agedDaysMinStatusO: route.params.agedDaysMinStatusO,
                            agedDaysMaxStatusO: route.params.agedDaysMaxStatusO,
                            unresolvedQuery: route.params.unresolvedQuery,
                            resubmittedMissingLink: route.params.resubmittedMissingLink,
                            agedDaysPaymentStatusMin: route.params.agedDaysPaymentStatusMin,
                            agedDaysPaymentStatusMax: route.params.agedDaysPaymentStatusMax,
                            paymentStatus: route.params.paymentStatus,
                            agedDaysMinStatusF: route.params.agedDaysMinStatusF,
                            agedDaysMaxStatusF: route.params.agedDaysMaxStatusF,
                            assignedUserId: route.params.assignedUserId,                            
                        }),
                    },
                },
                {
                    path: "DayBatchesSubmission",
                    name: "DayBatchesSubmission",
                    components: { default: () => import(/* webpackChunkName: "DayBatches" */ "./views/DayBatchesSubmission.vue") },
                    props: {
                        default: (route) => ({
                            providerId: route.params.providerId,
                            areaId: route.params.areaId,
                            agedDaysMin: route.params.agedDaysMin,
                            agedDaysMax: route.params.agedDaysMax,
                            allPrinted: route.params.allPrinted,
                            allPod: route.params.allPod,
                            allLink: route.params.allLink,
                        }),
                    },
                },
                {
                    path: "DayBatchesPostSubmission",
                    name: "DayBatchesPostSubmission",
                    components: { default: () => import(/* webpackChunkName: "DayBatches" */ "./views/DayBatchesPostSubmission.vue") },
                    props: {
                        default: (route) => ({
                            providerId: route.params.providerId,
                            areaId: route.params.areaId,
                            agedDaysMin: route.params.agedDaysMin,
                            agedDaysMax: route.params.agedDaysMax,
                            allPrinted: route.params.allPrinted,
                            allPod: route.params.allPod,
                            allLink: route.params.allLink,
                        }),
                    },
                },
                {
                    path: "Companies",
                    name: "Companies",
                    component: () => import(/* webpackChunkName: "Companies" */ "./views/Companies.vue"),
                },
                {
                    path: "Brokers",
                    name: "Brokers",
                    components: { default: () => import(/* webpackChunkName: "Brokers" */ "./views/Brokers.vue") },
                    props: {
                        default: (/*route*/) => ({
                            //someId: route.params.someId,
                            //
                        }),
                    },
                },
                {
                    path: "BrokerFirms",
                    name: "BrokerFirms",
                    components: { default: () => import(/* webpackChunkName: "BrokerFirms" */ "./views/BrokerFirms.vue") },
                    props: {
                        default: (/*route*/) => ({
                            //someId: route.params.someId,
                            //
                        }),
                    },
                },
                {
                    path: "Representatives",
                    name: "Representatives",
                    component: () => import(/* webpackChunkName: "Representatives" */ "./views/Representatives.vue"),
                },
                {
                    path: "RepresentativeProducts",
                    name: "RepresentativeProducts",
                    component: () => import(/* webpackChunkName: "RepresentativeProducts" */ "./views/RepresentativeProducts.vue"),
                },
                {
                    path: "SubscribeFormSubmissions",
                    name: "SubscribeFormSubmissions",
                    component: () => import(/* webpackChunkName: "SubscribeFormSubmissions" */ "./views/SubscribeFormSubmissions.vue"),
                },
                {
                    path: "Areas",
                    name: "Areas",
                    component: () => import(/* webpackChunkName: "Areas" */ "./views/Areas.vue"),
                },
                {
                    path: "Subscriptions",
                    name: "Subscriptions",
                    component: () => import(/* webpackChunkName: "Subscriptions" */ "./views/Subscriptions.vue"),
                },
                {
                    path: "ProviderGroups",
                    name: "ProviderGroups",
                    component: () => import(/* webpackChunkName: "ProviderGroups" */ "./views/ProviderGroups.vue"),
                },
                {
                    path: "Customers",
                    name: "Customers",
                    components: { default: () => import(/* webpackChunkName: "Customers" */ "./views/Customers.vue") },
                    props: { default: (route) => ({
                        status: route.params.status,
                        companyId: route.params.companyId
                    }) },
                },
                {
                    path: "Dashboard",
                    name: "Dashboard",
                    component: () => import(/* webpackChunkName: "Dashboard" */ "./views/ManaDashboard.vue"),//"./views/Dashboard.vue"),
                },
                //{
                //    path: "ManaDashboard",
                //    name: "ManaDashboard",
                //    component: () => import(/* webpackChunkName: "ManaDashboard" */ "./views/ManaDashboard.vue"),
                //},
                {
                    path: "Reports",
                    name: "Reports",
                    component: () => import(/* webpackChunkName: "Reports" */ "./views/Reports.vue"),
                },
                {
                    path: "Identities",
                    name: "Identities",
                    component: () => import(/* webpackChunkName: "Identities" */ "./views/Identities.vue"),
                },
                {
                    path: "Incidents",
                    name: "Incidents",
                    components: { default: () => import(/* webpackChunkName: "Incidents" */ "./views/Incidents.vue") },
                    props: {
                        default: (route) => ({
                            incidentId: route.params.incidentId,
                            providerId: route.params.providerId,
                            areaId: route.params.areaId,
                            agedDaysMin: route.params.agedDaysMin,
                            agedDaysMax: route.params.agedDaysMax,
                            isComplete: route.params.isComplete,
                            isIncidentComplete: route.params.isIncidentComplete,
                            isIncidentCompleteWithAvailableDocs: route.params.isIncidentCompleteWithAvailableDocs,
                            isAllPatientsComplete: route.params.isAllPatientsComplete,
                            isAllPatientsCompleteWithAvailableDocs: route.params.isAllPatientsCompleteWithAvailableDocs,
                            isAnyPatientsCompleteWithAvailableDocs: route.params.isAnyPatientsCompleteWithAvailableDocs,
                            isAnyPatientsComplete: route.params.isAnyPatientsComplete,
                            hasSuspendedPatient: route.params.hasSuspendedPatient,
                            isAllPatientsInAccount: route.params.isAllPatientsInAccount,
                            patientAgedDaysMin: route.params.patientAgedDaysMin,
                            patientAgedDaysMax: route.params.patientAgedDaysMax,
                            hnetRequestStatus: route.params.hnetRequestStatus,
                            isArSuspended: route.params.isArSuspended,
                            isAnyPatientMissingLegalDocuments: route.params.isAnyPatientMissingLegalDocuments,
                            isAnyPatientAdmitted: route.params.isAnyPatientAdmitted,
                            hasAr: route.params.hasAr,
                            isAnypatientMissingDocuments: route.params.isAnypatientMissingDocuments,
                            mcaIsFraudulent: route.params.mcaIsFraudulent,
                            mcaIsFinalised: route.params.mcaIsFinalised,
                            mcaIsSuspended: route.params.mcaIsSuspended,
                            mcaIsAdmitted: route.params.mcaIsAdmitted,
                            mcaIsVerified: route.params.mcaIsVerified,
                            marIsNew: route.params.marIsNew,
                            marIsRegistered: route.params.marIsRegistered,
                            marIsSuspended: route.params.marIsSuspended,
                            marIsComplete: route.params.marIsComplete,
                            marIsFinalised: route.params.marIsFinalised,
                            marIsFraudulent: route.params.marIsFraudulent
                        }),
                    },
                },
                {
                    path: "Billings",
                    name: "Billings",
                    components: { default: () => import(/* webpackChunkName: "Billings" */ "./views/Billings.vue") },
                    props: {
                        default: (route) => ({
                            notFinal: route.params.notFinal,
                            final: route.params.final,
                            submitted: route.params.submitted,
                            showNewForm: route.params.showNewForm,
                            lastInvoiceAgedDaysMin: route.params.lastInvoiceAgedDaysMin,
                            lastInvoiceAgedDaysMax: route.params.lastInvoiceAgedDaysMax,
                            billingId: route.params.billingId,
                        }),
                    },
                },
                {
                    path: "OldIncidents",
                    name: "OldIncidents",
                    components: { default: () => import(/* webpackChunkName: "OldIncidents" */ "./views/OldIncidents.vue") },
                    props: { default: (route) => ({ inAccount: route.params.inAccount, isComplete: route.params.isComplete, ageing: route.params.ageing }) },
                },
                {
                    path: "Providers",
                    name: "Providers",
                    component: () => import(/* webpackChunkName: "Providers" */ "./views/Providers.vue"),
                },
                {
                    path: "Users",
                    name: "Users",
                    component: () => import(/* webpackChunkName: "Users" */ "./views/Users.vue"),
                },
                {
                    path: "MedikreditClaimCsv",
                    name: "MedikreditClaimCsv",
                    component: () => import(/* webpackChunkName: "MedikreditClaimCsv" */ "./views/MedikreditClaimCsv.vue"),
                },
                {
                    path: "MedikreditClaim",
                    name: "MedikreditClaim",
                    component: () => import(/* webpackChunkName: "MedikreditClaim" */ "./views/MedikreditClaims.vue"),
                },
                {
                    path: "UnmatchedSmsReplyMessages",
                    name: "UnmatchedSmsReplyMessages",
                    component: () => import(/* webpackChunkName: "Identities" */ "./views/UnmatchedSmsReplyMessages.vue"),
                },
                {
                    path: "DeclinedSmsReplyMessages",
                    name: "DeclinedSmsReplyMessages",
                    component: () => import(/* webpackChunkName: "Identities" */ "./views/DeclinedSmsReplyMessages.vue"),
                },
                {
                    path: "Patients",
                    name: "Patients",
                    components: { default: () => import(/* webpackChunkName: "Patients" */ "./views/Patients.vue") },
                    props: {
                        default: (route) => ({
                            providerId: route.params.providerId,
                            areaId: route.params.areaId,
                            patientAgedDaysMin: route.params.patientAgedDaysMin,
                            patientAgedDaysMax: route.params.patientAgedDaysMax,
                            mcaIsFraudulent: route.params.mcaIsFraudulent,
                            mcaIsFinalised: route.params.mcaIsFinalised,
                            mcaIsSuspended: route.params.mcaIsSuspended,
                            mcaIsAdmitted: route.params.mcaIsAdmitted,
                            mcaIsVerified: route.params.mcaIsVerified,
                        }),
                    },
                }
            ],
        },
    ],
});

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    var lastRefresh = Date.parse(localStorage.getItem("last-refresh"));
    var todayDateString = new Date().toISOString().substring(0, 10);
    var logout = false;
    if (isNaN(lastRefresh)) {
        logout = true;
    } else {
        var lastRefreshDateString = new Date(lastRefresh).toISOString().substring(0, 10);
        if (todayDateString != lastRefreshDateString) {
            logout = true;
        }
    }

    if (logout == true) {
        localStorage.setItem("last-refresh", todayDateString);
        store.dispatch("authentication/logout");
        location.reload();
    }

    if (to.matched.some((m) => m.meta.requiresAuth) && !store.getters["authentication/isLoggedIn"]) {
        next({ name: "Login" });
    } else {
        next();
    }
});

export default router;
